import { render } from "./Index.vue?vue&type=template&id=6232465f&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6232465f"

export default script